import { NavLink } from 'react-router-dom';
import styles from './Nav.module.css';

/**
 * Navigation primitives shared by the app shell.
 *
 * NavItem   — a sidebar row (icon + label), active state from the router.
 * BottomNav / BottomNavItem — the mobile tab bar shown under 860px.
 * TopBar    — the sticky header strip with a title on the left and slots right.
 *
 * The layout that assembles these into the app shell comes in Stage 3; these
 * are the pieces it will be built from.
 */

export function NavItem({ to, icon, children, onClick, end = false }) {
  return (
    <NavLink
      to={to}
      end={end}
      onClick={onClick}
      className={({ isActive }) => `${styles.navitem} ${isActive ? styles.active : ''}`}
    >
      <span className={styles.ic} aria-hidden="true">
        {icon}
      </span>
      {children}
    </NavLink>
  );
}

export function BottomNav({ children }) {
  return (
    <nav className={styles.botnav} aria-label="Primary">
      {children}
    </nav>
  );
}

export function BottomNavItem({ to, icon, children, end = false }) {
  return (
    <NavLink
      to={to}
      end={end}
      className={({ isActive }) => `${styles.bn} ${isActive ? styles.bnActive : ''}`}
    >
      <span className={styles.bnIc} aria-hidden="true">
        {icon}
      </span>
      {children}
    </NavLink>
  );
}

export function TopBar({ title, children }) {
  return (
    <header className={styles.topbar}>
      <h1 className={styles.topTitle}>{title}</h1>
      <div className={styles.topRight}>{children}</div>
    </header>
  );
}

/** Circular avatar chip in the top bar. */
export function Avatar({ children = '🦆', className = '' }) {
  return (
    <span className={`${styles.avatar} ${className}`} aria-hidden="true">
      {children}
    </span>
  );
}
